import { observer } from "mobx-react";
import React, { useContext, useEffect, useRef } from "react";

import { OfferStoreContext } from "@gp/components";

import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import {
	BetBuilderPicksPopupFooter,
	BetBuilderPicksPopupHeader,
} from "./components/BetBuilderPopup";
import { createPortal } from "react-dom";
import { useFixBody } from "@state/hooks/shared";
import BetBuilderPicksPopupEventBody from "./components/BetBuilderPopup/BetBuilderPicksPopupEventBody";

export default observer(function BetBuilderPicksEventPopup() {
	const popupElement = useRef<null | HTMLDivElement>(null);
	//@ts-expect-error
	const store: AdditionalOfferViewStore | EventViewStore =
		useContext(OfferStoreContext);

	useFixBody(
		true,
		store?.betBoosterEventPicks?.betBuilderPicksStore?.isPopupDisplayed
	);

	useEffect(() => {
		popupElement.current?.scrollTo({ top: 0 });
	}, [store?.betBoosterEventPicks?.betBuilderPicksStore?.selectedBetSlip]);

	if (!store?.betBoosterEventPicks?.betBuilderPicksStore) {
		return null;
	}

	if (!store.betBoosterEventPicks.betBuilderPicksStore.selectedBetSlip) {
		return null;
	}

	return createPortal(
		<div className="popup popup--full">
			<div className="popup__card popup--most__card popup--bbp__card">
				<BetBuilderPicksPopupHeader
					slipNumber={
						store.betBoosterEventPicks.betBuilderPicksStore
							.slipIndex
					}
					isLive={
						store.betBoosterEventPicks.betBuilderPicksStore
							.selectedBetSlip.isLive
					}
					BBPick={
						store.betBoosterEventPicks.betBuilderPicksStore
							.selectedBetSlip
					}
					cb={
						store.betBoosterEventPicks.betBuilderPicksStore
							.deactivatePopup
					}
				/>
				<div
					className="popup__body popup--qp__body popup--bbp__body"
					ref={popupElement}
				>
					<BetBuilderPicksPopupEventBody
						key={
							store.betBoosterEventPicks.betBuilderPicksStore
								.selectedBetSlip.id
						}
						BBPick={
							store.betBoosterEventPicks.betBuilderPicksStore
								.selectedBetSlip
						}
					/>
				</div>
				<BetBuilderPicksPopupFooter
					slip={
						store.betBoosterEventPicks.betBuilderPicksStore
							.selectedBetSlip
					}
					store={store.betBoosterEventPicks.betBuilderPicksStore}
				/>
			</div>
		</div>,
		document.getElementById("app-modal") || document.body
	);
});
